import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { ActiveSubscription, SubscriptionStatus } from '../types/plan';

class SubscriptionService {
  /**
   * Busca assinaturas ativas do usuário logado via Firestore (sem cold start de Cloud Function).
   */
  async getActiveSubscriptions(): Promise<ActiveSubscription[]> {
    const userId = auth.currentUser?.uid;
    if (!userId) {
      return [];
    }

    try {
      const q = query(
        collection(db, 'subscriptions'),
        where('userId', '==', userId),
        where('status', '==', SubscriptionStatus.ACTIVE),
        limit(100)
      );

      const snapshot = await getDocs(q);
      return snapshot.docs.map((doc) => ({
        id: doc.id,
        ...(doc.data() as Omit<ActiveSubscription, 'id'>),
      }));
    } catch (error) {
      console.error('Erro ao buscar assinaturas ativas:', error);
      throw error;
    }
  }

  /**
   * Verifica se o usuário tem uma assinatura ativa de um tipo específico
   */
  hasActiveSubscription(
    subscriptions: ActiveSubscription[],
    sessionLabel?: string
  ): boolean {
    return subscriptions.some(
      sub => !sessionLabel || sub.sessionLabel === sessionLabel
    );
  }

  /**
   * Agrupa assinaturas por tipo de sessão
   */
  groupBySessionType(subscriptions: ActiveSubscription[]): {
    constellation: ActiveSubscription[];
    participation: ActiveSubscription[];
    hours: ActiveSubscription[];
    other: ActiveSubscription[];
  } {
    return {
      constellation: subscriptions.filter(
        sub => sub.sessionLabel === 'Constelação'
      ),
      participation: subscriptions.filter(
        sub => sub.sessionLabel === 'Participação'
      ),
      hours: subscriptions.filter(
        sub => sub.billingType === 'hours'
      ),
      other: subscriptions.filter(
        sub => !sub.sessionLabel && sub.billingType !== 'hours'
      ),
    };
  }
}

const subscriptionService = new SubscriptionService();
export default subscriptionService;
